/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import { useToasts } from "react-toast-notifications";

const useError = () => {
  const { addToast } = useToasts();

  function showDefaultApiError(
    errorList,
    defaultMessage = "Error: Unable to retrieve reports",
    options = {}
  ) {
    if (errorList.errors) {
      errorList.errors.forEach(() => {
        addToast(defaultMessage, {
          appearance: "error",
          ...options,
        });
      });
    }
  }

  return showDefaultApiError;
};

export default useError;
